import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sprint: {
		id: 'software-burn-reports-common.controls.sprint',
		defaultMessage: 'Sprint',
		description: 'Sprint label for selecting the sprint',
	},
	estimationField: {
		id: 'software-burn-reports-common.controls.estimation-field',
		defaultMessage: 'Estimation field',
		description: 'Estimation field label for selecting the estimation field',
	},
	optionStatisticIssueCount: {
		id: 'software-burn-reports-common.controls.option-statistic-issue-count',
		defaultMessage: 'Issue count',
		description: 'Issue count estimation label for filter controls',
	},
	optionStatisticStoryPoints: {
		id: 'software-burn-reports-common.controls.option-statistic-story-points',
		defaultMessage: 'Story points',
		description: 'Story points estimation label for filter controls',
	},
	optionStatisticOriginalEstimate: {
		id: 'software-burn-reports-common.controls.option-statistic-original-estimate',
		defaultMessage: 'Time',
		description: 'Time estimation label for filter controls',
	},
});
